import { render, staticRenderFns } from "./form-contact-us.vue?vue&type=template&id=bbea2a1e&"
import script from "./form-contact-us.vue?vue&type=script&lang=js&"
export * from "./form-contact-us.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Volumes/Third Coast Creative/repos/MidwestBeltone.Iframes/MidwestBeltone.Iframes.Web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bbea2a1e')) {
      api.createRecord('bbea2a1e', component.options)
    } else {
      api.reload('bbea2a1e', component.options)
    }
    module.hot.accept("./form-contact-us.vue?vue&type=template&id=bbea2a1e&", function () {
      api.rerender('bbea2a1e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "Frontend/vue/pages/form-contact-us.vue"
export default component.exports